import { useCallback } from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import { useNotificationStore } from '../../stores/notificationStore';

/**
 * Global notification stack — renders MUI Snackbar/Alert for each
 * notification in the store. Mount once in App.tsx.
 */
export const NotificationStack = () => {
  const notifications = useNotificationStore((s) => s.notifications);
  const dismiss = useNotificationStore((s) => s.dismiss);

  const handleClose = useCallback(
    (id: string) => () => {
      dismiss(id);
    },
    [dismiss],
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 1,
        maxWidth: 420,
      }}
    >
      {notifications.map((n) => (
        <Snackbar
          key={n.id}
          open
          autoHideDuration={n.autoHide ?? 5000}
          onClose={handleClose(n.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'static' }}
        >
          <Alert
            onClose={handleClose(n.id)}
            severity={n.severity}
            variant="filled"
            sx={{ width: '100%', fontSize: 12 }}
          >
            {n.message}
          </Alert>
        </Snackbar>
      ))}
    </Box>
  );
};
